import React from "react";
import { useSelector } from "react-redux";
import ByFolder from "layout/dictionarySearch/folder/byFolder";
import ByDocument from "layout/dictionarySearch/folder/byDocument";
import { folderBy } from "layout/dictionarySearch/constants";

const DictionarySearchFolder = () => {
  const by = useSelector((state) => state.dictionarySearch.config.folderBy);

  return by === folderBy.folder ? <ByFolder /> : <ByDocument />;
};

export default DictionarySearchFolder;
